<template>
  <div class="notification-competitor-thread">
    <div class="notification-competitor-thread__banner">
      <BaseIcon name="bookmark-filled-check" />
      <span class="notification-competitor-thread__banner-name">{{ competitorName }}</span>
    </div>

    <div v-for="notification in notifications" :key="notification.id" class="notification-competitor-thread__item">
      <span class="notification-competitor-thread__connector"></span>
      <NotificationItem
        :notification="notification"
        :tender="tenderById(notification.content.subjectId)"
        @open="$emit('open', notification)"
        @mark-read="$emit('mark-read', notification)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseIcon from '@/components/base/BaseIcon';
import NotificationItem from '@/components/notifications-center/NotificationItem.vue';

export default {
  name: 'NotificationCompetitorThread',
  components: {
    BaseIcon,
    NotificationItem,
  },
  props: {
    competitorName: {
      type: String,
      required: true,
    },
    notifications: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters('notifications', ['tenderById']),
  },
};
</script>

<style lang="scss" scoped>
.notification-competitor-thread {
  display: flex;
  flex-direction: column;
  gap: $space-sm;
  width: 100%;
  padding: $space-sm;

  &__banner {
    display: flex;
    align-items: center;
    gap: $space-sm;
    width: 100%;
    height: 32px;
    padding: $space-sm;
    border: 1px solid $color-accent-500;
    border-radius: $radius-md;
    background: $color-accent-100;

    .base-icon {
      flex-shrink: 0;
      width: 18px;
      height: 18px;
      color: $color-text-body;
    }
  }

  &__banner-name {
    overflow: hidden;
    color: $color-text-title;
    font-size: $font-size-xsmall;
    font-weight: $font-weight-bold;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__item {
    display: flex;
    gap: $space-3;
    padding-left: $space-3;
  }

  &__connector {
    flex-shrink: 0;
    width: 1px;
    background: $color-border;
  }
}
</style>
